// Module
var code = "<div class=\"show-empty-values\"> <input type=\"checkbox\" class=\"empty-value\" id=\"checkbox\" @click=\"showEmptyValues()\" v-model=\"showEmpty\"> <label class=\"empty-value\" for=\"checkbox\">{{$t('resource.showEmptyValues')}}</label> </div>";
// Exports
module.exports = code;